import { Form, FormLayout, Modal, Checkbox, TextField } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useField, useForm } from '@shopify/react-form';
import { TypedTransactions_callback, useMutateUpdateTransactionCallback } from 'queries/transactions.query';

export default function TransactionsCallbackModal({
  onClose,
  show,
  currentEntity,
}: {
  onClose: Function;
  show: boolean;
  currentEntity?: TypedTransactions_callback;
}) {
  const { mutateAsync: updateEntity, isPending: updating, isSuccess: updateSuccess } = useMutateUpdateTransactionCallback();

  const [entity, setEntity] = useState<TypedTransactions_callback>(null);

  useEffect(() => {
    setEntity(currentEntity ?? null);
  }, [currentEntity]);

  const useFields = {
    note: useField<string>({
      value: entity?.note ?? '',
      validates: [],
    }),
    content: useField<string>({
      value: entity?.content ?? '',
      validates: [],
    }),
  };

  const {
    fields,
    submit,
    dirty,
    reset: resetForm,
  } = useForm({
    fields: useFields,
    async onSubmit(values) {
      await updateEntity({
        id: entity.id,
        note: values.note,
        content: values.content,
      });

      return { status: 'success' as const };
    },
  });

  useEffect(() => {
    if (updateSuccess) {
      resetForm();
      onClose();
    }
  }, [updateSuccess]);

  return (
    <Modal
      open={show}
      onClose={() => onClose()}
      title={entity?.id ? `Cập nhật callback #${entity.id}` : 'Cập nhật callback'}
      primaryAction={{
        content: 'Cập nhật',
        disabled: !dirty,
        loading: updating,
        onAction: submit,
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: () => onClose(),
        },
      ]}
    >
      <Modal.Section>
        <Form onSubmit={submit}>
          <FormLayout>
            <TextField
              label="Nội dung chuyển khoản"
              autoComplete="off"
              {...fields.content}
              multiline={1}
              helpText="Tránh sửa nội dung chuyển khoản, nếu sửa nên copy xuống ghi chú để lưu trữ sau này."
            />
            <TextField label="Ghi chú" autoComplete="off" {...fields.note} multiline={3} />
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
}

